// extracted by mini-css-extract-plugin
export var content = "People-module--content--6pZbn";
export var eyebrow = "People-module--eyebrow--xgktk";
export var half = "People-module--half---osRZ";
export var reverse = "People-module--reverse--z1Q4+";
export var root = "People-module--root--HaM6N";
export var text = "People-module--text--x3nrx";